module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_hotel_sp-cea92d0dc81dc50c3e18d30ffc5950ab.svg";